export const documentUrls = {
	privacy: "https://dransay.com/datenschutz/",
	faq: "https://dransay.com/faq/",
	terms: "https://dransay.com/agb/",
	accessoriesTerms: "https://dransay.com/agb-otc",
	impressum: "https://dransay.com/impressum/",
	partnerOffers: "https://deals.dransay.com",
	followUpPrescriptions: "https://dransay.com/online-rezept",
	followUpPrescriptionsSearch: "https://folgerezept.dransay.com/",
	firstTimePatients: "https://dransay.com/cannabis-rezept-online#complains",
} as const;
